/**
 * Prüft, ob ein Produkt „neu" ist – d.h. innerhalb der letzten NEW_PRODUCT_DAYS
 * Tage erstellt wurde. Kein manuelles Markieren nötig, der Badge verschwindet
 * automatisch nach Ablauf des Zeitraums.
 */
export const NEW_PRODUCT_DAYS = 14;

export const isNewProduct = (product) => {
  if (!product?.created_at) return false;
  try {
    const created = new Date(product.created_at);
    if (Number.isNaN(created.getTime())) return false;
    const ageMs = Date.now() - created.getTime();
    return ageMs >= 0 && ageMs <= NEW_PRODUCT_DAYS * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
};
